import { defaultConfig, defineSlotRecipe } from '@chakra-ui/react';

import merge from 'lodash/merge';

export const toastSlotRecipe = defineSlotRecipe(
    merge(defaultConfig?.theme?.slotRecipes?.toast, {
        base: {
            root: {
                // missing border-box on legacy
                boxSizing: 'border-box',
            },
            description: {
                opacity: 0.9,
            },
            title: {
                fontWeight: 'bold',
            },
            closeTrigger: {
                cursor: 'pointer',
                bgColor: 'transparent',
                border: 0,
                color: 'white',
                fontSize: '1.25rem',

                _hover: {
                    opacity: 0.75,
                },
            },
        },
        variants: {
            variant: {
                dark: {
                    root: {
                        backgroundColor: 'gray.800',
                        color: 'white',
                        borderRadius: 'md',
                        px: { base: 3, md: 3 },
                        py: { base: 2, md: 3 },
                    },
                    description: {
                        opacity: 1,
                        fontSize: { base: 'sm', md: 'md' },
                        whiteSpace: { base: 'normal', md: 'pre-line' },
                    },
                },
            },
        },
    }),
);
